import { DateTime } from "luxon";

/**
 * Start of the calendar week containing `date`, honoring the coach's
 * first-day-of-week preference (FullCalendar numbering: 0=Sunday .. 6=Saturday).
 * Luxon weekday is 1=Monday .. 7=Sunday, so normalize via modulo 7.
 */
export function startOfCalendarWeek(
  date: DateTime,
  firstDay: number,
): DateTime {
  const offset = ((date.weekday % 7) - firstDay + 7) % 7;
  return date.startOf("day").minus({ days: offset });
}
